export const environment = {
  production: false,
  api_qaapis: 'https://qaapis.virtualplace.online:8099/',
  api_apisqa: 'https://apisqa.virtualplace.online:8099/',
  apis_goadmin: 'https://apisgoadmi.virtualplace.online/',
  api_pasarela: 'https://apiqapagos.onepeoplecloud.com:8109/',
  paypal_id:
    'AV9ESl12tu4kCYqMc0YtF1sSWVYvRIToM1pdCBpzno4qQaeDio5r4ELhTEwA-vzV_aILQJlEyPcwBtlL',
  paypal_secret:
    'EJYe8wwIDFOm-mfONoKBlbm48WgkfjjftZM59UltBCcKupXtuIjiyOs0mKT3AFh4i6XfLqOILtZRsXBN',
  open_pay: {
    id: 'mvt8wspms2nfjw7zx6tq',
    private_key: 'pk_d4bc7f033d5846c1b7e750d42e3854d8',
    mode: false,
  },
  api_pasarela_forma_pago:
    'https://apiqapagos.onepeoplecloud.com:8109/api/FormasDePago/',
  api_latino: 'https://apiqalatino.virtualplace.online',
  
  dashboard: 'https://angular.virtualplace.online/api/v1/',
  dashboardT: 'https://qaapis.virtualplace.online:8099/',
  //dashboardT: 'https://localhost:5001/',


  userphotos: 'https://qatarjetasdoc.virtualplace.online/fotosUsuario/',
  coverphotos: 'https://tarjetasf.virtualplace.online/fotosPortada/',
  logo: 'https://tarjetasf.virtualplace.online/Logotipo/',
  cardphotos: 'https://virtualplace.online/fotosTarjeta/',
  documents: 'https://tarjetasf.virtualplace.online/Documentos/',
  imagesservices: 'https://tarjetasf.virtualplace.online/imagenesServicios/',
  api_key: '7d46e5a4-bfd8-4fa1-bd80-4ac84e6c2c8c',
  api_key_latino: '7939a3af-c37d-4452-b585-5b1c5fa7adf8',
};
